import styled from "styled-components";

function PossiveisRespostas() {
    return(Lista)
}

export {PossiveisRespostas};

const Lista = [
    "Infecção por Bactéria",
    "Infecção por Vírus",
    "Infecção por Fungos",
    "Infecção por Parasita",
    "Infecção Crônica",
    "Anemia",
    "Saudável"

]